import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCEXT } from "../../../../js/lib/ext/Ext";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { DialogManager } from "../../Managers/DialogManager";
import { EventableMixin } from "../../events/EventableMixin";
import { ApplicationData } from "../ApplicationData";
import { SimpleErrorDialog } from "../controls/simpleErrorDialog";
import { ResourceUtils } from "../utils/resourceUtils";
import { LibraryThing } from "../widget/LibraryThingWidget";

export class VirtualShelfView {
	constructor() {
		$.extend(true, this, {
			id: "virtualShelf",
			containerClass: "virtualShelfDialogContainer",
			bookJacketId: "_virtualShelfBookJacket",
			events: [
				LS2PAC_CONSTANTS.Events.onHome,
				LS2PAC_CONSTANTS.Events.onLogout,
				LS2PAC_CONSTANTS.Events.onTimeout,
				LS2PAC_CONSTANTS.Events.onShowVirtualShelf,
				LS2PAC_CONSTANTS.Events.onGetVirtualShelfResourcesResponse
			],
			virtualShelfTemplateUrl: "tmpl/virtualShelf/virtualShelf.html",
			virtualShelfCoverTemplateUrl: "tmpl/virtualShelf/virtualShelf_bookCover.html",
			virtualShelfSpineTemplateUrl: "tmpl/virtualShelf/virtualShelf_bookSpine.html",
			currentResource: null,
			resources: null,
			hasEvents: false,
			endOfLeftList: false,
			endOfRightList: false,
			templates: false,
			isOpen: false,
			isOpening: false,
			backgroundColor: ["SpineRed", "SpineBlue", "SpineGreen"],
			spineHeight: ["short", "medium", "tall"]
		}, {});

		this.addEvents();
	}
	handleDialog(event) {
		if (event.success) {
			if (this.isOpen) {
				$("#" + this.id).spin(false);
			}
			if (this.resources.length > 0) {
				this.prepareDialogContent();
			} else {
				this.handleError(ApplicationData.language.virtualShelfNoCopiesError);
			}
		} else {
			this.handleError(ApplicationData.language.virtualShelfServiceError);
		}
	}
	close() {
		this.isOpen = false;
		this.enableVirtualShelfLink();
		DialogManager.close();
	}
	enableVirtualShelfLink() {
		$("a.virtualShelf")
			.prop("disabled", false)
			.removeClass(LS2PAC_CONSTANTS.CssClasses.disabled);
	}
	handleError(message) {
		this.enableVirtualShelfLink();

		SimpleErrorDialog.show(message);
	}
	prepareDialogContent() {
		var _this = this;
		if (!this.isOpen) {
			TemplateEngine.compile(this.virtualShelfTemplateUrl, {
				resources: this.resources
			}, function (content) {
				_this.isOpen = true;
				_this.isOpening = false;
				_this.setUpVirtualShelfDialog(content);
			});
		} else {
			this.updateVirtualShelf();
			this.isOpening = false;
		}

	}
	setUpVirtualShelfDialog(content) {
		var _this = this;
		var extraClasses = this.containerClass;
		DialogManager.show({
			content: content,
			buttons: "",
			// okText: ApplicationData.language.close,
			dialogTitle: ApplicationData.language.virtualShelf,
			extraClass: extraClasses,
			showCancel: false,
			callback: function () {
				_this.updateVirtualShelf();
				_this.addDomEventsForVirtualShelf();
			},
			closeCallback: function () {
				_this.isOpen = false;
				_this.enableVirtualShelfLink();
			}
		});
	}
	updateVirtualShelf() {
		this.addBooks();
		this.addArt();
		this.togglePageButtons();
	}
	addBooks() {
		var response = '';
		var total = this.resources.length;
		var numOfCovers = 5;
		var numOfSpines = Math.ceil(total - numOfCovers);
		var books = this.resources;
		var templateToUse = null;

		var marginWidth = 1;
		var spineWidth = 25;
		var coverWidth = 120 + (marginWidth * 2);
		var totalWidth = 0;
		var itemWidth = 0;

		var options = null;
		var coversAtLeft = this.endOfLeftList || false;
		var coversAtRight = this.endOfRightList || false;

		for (var i = 0; i < total; i++) {
			templateToUse = this.coverTemplate;
			itemWidth = coverWidth;
			options = {
				resource: this.resources[i],
				index: i,
				callNumber: ResourceUtils.getCallNumber(books[i]),
				height: this.spineHeight[Math.floor(Math.random() * 3)],
				color: this.backgroundColor[Math.floor(Math.random() * 3)]
			};

			if ((coversAtLeft && i >= numOfCovers) || (coversAtRight && i < (total - numOfCovers))) {
				templateToUse = this.spineTemplate;
				itemWidth = spineWidth;
			} else if (!coversAtLeft && !coversAtRight
				&& (i < (numOfSpines / 2) || i >= ((numOfSpines / 2) + numOfCovers))) {
				templateToUse = this.spineTemplate;
				itemWidth = spineWidth;
			}

			totalWidth += itemWidth;

			response += templateToUse.populate(options);
		}

		$("#" + this.id)
			.html(response)
			.css("width", totalWidth + "px")
			.css("margin", "0 auto");
	}
	addArt() {
		if (this.resources.length == 0) {
			return;
		}
		var total = this.resources.length;
		var numOfCovers = 5;
		var numOfSpines = total - numOfCovers;

		//var overallHeight = $( "#" + this.id ).height();
		var overallHeight = 225;
		var topMargin = null;
		var index = null;
		var start = null;
		var end = null;

		if (!this.endOfLeftList && !this.endOfRightList) { // add middle 5 books
			var numOfSpinesPerSide = Math.ceil(numOfSpines / 2);
			start = numOfSpinesPerSide;
			end = numOfCovers + numOfSpinesPerSide;
		} else if (this.endOfLeftList) { // add first 5 books
			start = 0;
			end = numOfCovers;
		} else if (this.endOfRightList) { // add last 5 books
			start = numOfSpines;
			end = total;
		}

		var booksWithBookjackets = [];
		for (index = start; index < end; index++) {
			booksWithBookjackets.push(this.resources[index]);
		}

		for (var j = 0, length = booksWithBookjackets.length; j < length; j++) {
			var bookJacketContainer = $("#" + booksWithBookjackets[j].id + this.bookJacketId);
			(function (bookJacketContainer) {
				bookJacketContainer.parent("a").css("height", overallHeight);
				bookJacketContainer.addCoverArt(LibraryThing.enums.requestType.bookJacketMedium, booksWithBookjackets, j, true, false, function (success) {
					//var jacketHeight = bookJacketContainer.height();
					//topMargin = overallHeight - jacketHeight;
					//bookJacketContainer.css( "marginTop", topMargin + "px" );
				}, true, false, true);
			})(bookJacketContainer);

		}
	}
	addDomEventsForVirtualShelf() {
		var $form = $("." + this.containerClass), _this = this;

		if (!this.hasEvents) {
			$form.on("click", ".next", function (event) {
				if (!_this.isOpening) {
					$("#" + _this.id).spin("large");
					var position = _this.resources.length - 1;

					_this.currentResource = _this.resources[position];
					_this.isOpening = true;
					TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onGetVirtualShelfResources, {
						resource: _this.currentResource,
						type: "next"
					});
				}
				return false;
			});

			$form.on("click", ".prev", function (event) {
				if (!_this.isOpening) {
					$("#" + _this.id).spin("large");

					_this.currentResource = _this.resources[0];
					_this.isOpening = true;
					TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onGetVirtualShelfResources, {
						resource: _this.currentResource,
						type: "previous"
					});
				}
				return false;
			});

			$form.on("click", ".spine a", function (event) {
				if (!_this.isOpening) {
					$("#" + _this.id).spin("large");
					var section = $(event.currentTarget).data("section");
					var index = $(event.currentTarget).data("index");

					_this.currentResource = _this.resources[index];
					_this.isOpening = true;
					TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onGetVirtualShelfResources, {
						resource: _this.currentResource,
						type: "spine",
						index: index
					});
				}
				return false;
			});

			$form.on("click", ".cover a", function (event) {
				var section = $(event.currentTarget).data("section");
				var index = $(event.currentTarget).data("index");
				_this.currentResource = _this.resources[index];

				TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onGoToFullDetailsFromVirtualShelf, {
					resource: _this.currentResource
				});

				var hashObject = {
					section: "resource",
					currentIndex: 0,
					resourceId: _this.currentResource.id,
					view: "fullDetailsDetailsTab"
				};

				location.href = _this.getURLParamsForHash(hashObject);
				DialogManager.close();
				return false;
			});
			this.hasEvents = true;
		}
	}
	togglePageButtons() {
		var $shelf = $("." + this.containerClass);
		var $prev = $shelf.find(".prev");
		var $next = $shelf.find(".next");
		if (this.endOfLeftList) {
			$prev.hide();
		} else {
			$prev.show();
		}
		if (this.endOfRightList) {
			$next.hide();
		} else {
			$next.show();
		}
	}
	getURLParamsForHash(hashObject) {
		return "#section=" + hashObject.section +
			"&currentIndex=" + hashObject.currentIndex +
			"&resourceId=" + hashObject.resourceId +
			"&view=" + hashObject.view;
	}
}

VirtualShelfView.prototype[LS2PAC_CONSTANTS.Events.onHome] = function ( event ) {
	this.close();
};

VirtualShelfView.prototype[LS2PAC_CONSTANTS.Events.onLogout] = function ( event ) {
	this.close();
};

VirtualShelfView.prototype[LS2PAC_CONSTANTS.Events.onTimeout] = function ( event ) {
	this.close();
};

VirtualShelfView.prototype[LS2PAC_CONSTANTS.Events.onShowVirtualShelf] = function ( event ) {
	this.currentResource = event.resource;
	TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onGetVirtualShelfResources, {
		resource: this.currentResource,
		type:     "open"
	} );
};

VirtualShelfView.prototype[LS2PAC_CONSTANTS.Events.onGetVirtualShelfResourcesResponse] = function ( event ) {
	this.resources = event.resources;
	this.endOfLeftList = event.endOfLeftList;
	this.endOfRightList = event.endOfRightList;

	var _this = this;
	if( !this.templates ) {
		$.when(
			$.get( _this.virtualShelfSpineTemplateUrl ),
			$.get( _this.virtualShelfCoverTemplateUrl )
		).then( function ( spine, cover ) {
				_this.spineTemplate = TLCEXT.Template( spine[0] );
				_this.coverTemplate = TLCEXT.Template( cover[0] );
				_this.templates = true;

				_this.handleDialog( event );
			} );
	} else {
		_this.handleDialog( event );
	}
};

EventableMixin.call( VirtualShelfView.prototype );
